import { useLoaderData } from 'react-router'

import { EMPTY_LIST } from '../../../constants/common'
import { EmailProfilePrintLayout } from '../EmailProfilePrintLayout'

function EmailMessageProfilePrint() {
  const data = useLoaderData()

  return (
    <EmailProfilePrintLayout
      messages={data ? [data] : EMPTY_LIST}
      requestNumber={data?.requestNumber}
      subject={data?.subject}
    />
  )
}

export default EmailMessageProfilePrint
